function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import styles from './Option.scss';

var Option = function Option(_ref) {
  var handleSelect = _ref.handleSelect,
      children = _ref.children,
      label = _ref.label,
      value = _ref.value,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;

  var selectValue = function selectValue() {
    return handleSelect(value);
  };

  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: selectValue,
    label: label,
    value: value,
    className: classnames(styles.option, _defineProperty({}, styles.selected, isSelected)),
    disabled: isDisabled
  }, children || label);
};

export default Option;